import Modal from "components/Modal/Modal";
import { EuiText, EuiIcon, EuiFlexGroup, EuiFlexItem, EuiSpacer } from "@elastic/eui";
import Button from "components/Buttons/Button";

const ConfirmModal = ({
  title,
  message,
  children,
  onClose,
  onConfirm,
  cancelButtonText = "Cancel",
  confirmButtonText = "Continue",
  maxWidth = 550,
  confirmButtonDisabled = false,
  isLoading = false,
}: any) => {
  return (
    <Modal
      title={title}
      onClose={onClose}
      maxWidth={maxWidth}
      children={
        children ? (
          children
        ) : (
          <EuiFlexGroup alignItems="center" responsive={false}>
            {title.includes("Delete") && (
              <>
                <EuiSpacer size="xs" />
                <EuiFlexItem grow={false} style={{ width: "40px" }}>
                  <EuiIcon type="trash" color="var(--red)" size="xl" />
                </EuiFlexItem>
              </>
            )}
            <EuiFlexItem style={{ padding: "16px" }}>
              <EuiSpacer size="xs" />
              <EuiText>{message}</EuiText>
            </EuiFlexItem>
          </EuiFlexGroup>
        )
      }
      footer={
        <EuiFlexGroup gutterSize="m" justifyContent="flexEnd">
          <EuiFlexItem grow={false}>
            <Button type="secondary" text={cancelButtonText} onClick={onClose} />
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <Button
              type="primary"
              isLoading={isLoading}
              disabled={confirmButtonDisabled}
              text={confirmButtonText}
              onClick={onConfirm}
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      }
    />
  );
};

export default ConfirmModal;
